<template>
    <div class="reconsent-page">
        <div class="main-content">
            <div ref="header" class="header-container">
                <div class="header-outer">
                    <div class="header-inner">
                        <div class="header-wrapper">
                            <img
                                src="@/assets/icon/nestle-header@3x.png"
                                alt="img-head"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="reconsent-body">
                <div class="reconsent-main">
                    <div v-if="single" class="reconsent-header_single">
                        <div v-if="privacy" class="single_text">
                            เงื่อนไขและข้อกำหนด
                        </div>
                        <div v-else class="single_text">
                            นโยบายความเป็นส่วนตัว
                        </div>
                    </div>
                    <div v-else class="reconsent-header_multi">
                        <div
                            class="multi_text"
                            :class="{ active: activeTab == 'term' }"
                            @click="toggleTab('term')"
                        >
                            เงื่อนไขและข้อกำหนด
                        </div>
                        <div
                            class="multi_text"
                            :class="{ active: activeTab == 'privacy' }"
                            @click="toggleTab('privacy')"
                        >
                            นโยบายความเป็นส่วนตัว
                        </div>
                    </div>
                    <!-- eslint-disable vue/no-v-html -->
                    <div
                        v-if="activeTab == 'term'"
                        class="reconsent-desc"
                        v-html="termData"
                    ></div>
                    <!--eslint-enable-->
                    <!-- eslint-disable vue/no-v-html -->
                    <div
                        v-else
                        class="reconsent-desc"
                        v-html="privacyData"
                    ></div>
                    <!--eslint-enable-->
                </div>
                <div class="btn-wrapper">
                    <div class="accept-btn" @click="toggleAccept">ตกลง</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
//core
import BzbsApi from "@/core/Account/service/BzbsProfile.js";
import BzbsCustom from "@/core/Custom/service/BzbsCustom.js";
//helper
import CacheHelper from "@/helper/CacheHelper.js";
import Locale from "@/helper/locale/locale.js";
export default {
    name: "CookiePolicy",
    data: function() {
        return {
            lbl: Locale.getLbl(),
            loading: false,
            single: false,
            activeTab: "term",
            acceptTerm: true,
            acceptPrivacy: true,
            termData: "",
            privacyData: "",
            objParams: {},

            privacy: this.$route.query.privacy,
            term: this.$route.query.term,
            current_privacy: this.$route.query.current_privacy,
            current_term: this.$route.query.current_term,
            target_page: this.$route.query.target_page,

            cacheHelper: new CacheHelper()
        };
    },
    created: function() {
        this.init();
    },
    methods: {
        async init() {
            if (this.term || this.privacy) {
                this.single = true;
                this.term
                    ? (this.activeTab = "privacy")
                    : (this.activeTab = "term");
            } else {
                this.single = false;
                this.acceptTerm = false;
                this.acceptPrivacy = false;
            }
            if (!this.term) {
                this.termData = await this.getTermData();
            }
            if (!this.privacy) {
                this.privacyData = await this.getPolicyData();
            }
        },
        getTermData() {
            const url =
                "/nestle/pdpaconsent/terms/" +
                Vue.bzbsConfig.client_id +
                "/" +
                this.current_term +
                "/" +
                Locale.getLocaleCode();
            return new Promise((resolve, reject) => {
                BzbsCustom.apiGetCustom(url)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        getPolicyData() {
            const url =
                "/nestle/pdpaconsent/privacy/" +
                this.current_privacy +
                "/" +
                Locale.getLocaleCode();
            return new Promise((resolve, reject) => {
                BzbsCustom.apiGetCustom(url)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        toggleTab(tab) {
            this.activeTab = tab;
        },
        toggleAccept() {
            if (!this.single) {
                this.activeTab == "term"
                    ? (this.acceptTerm = true)
                    : (this.acceptPrivacy = true);
                this.activeTab == "term"
                    ? (this.activeTab = "privacy")
                    : (this.activeTab = "term");
                console.log(this.acceptTerm && this.acceptPrivacy);
                if (this.acceptTerm && this.acceptPrivacy) {
                    return this.updateConsent();
                }
                this.scrollToTop();
            } else {
                this.updateConsent();
            }
        },
        scrollToTop() {
            this.$refs["header"].scrollIntoView({ behavior: "smooth" });
        },
        updateConsent() {
            if (!this.term) {
                this.objParams["termandcondition"] = this.current_term;
            }
            if (!this.privacy) {
                this.objParams["dataprivacy"] = this.current_privacy;
            }

            return new Promise((resolve, reject) => {
                BzbsApi.updateConsent(
                    this.cacheHelper.getCache("BzbsUser").token,
                    this.objParams
                ).subscribe(
                    response => {
                        if (this.target_page) {
                            this.$router.push(this.target_page);
                        } else {
                            this.$router.push("/");
                        }
                        resolve(response);
                    },
                    err => {
                        reject(err);
                    }
                );
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/_mixin.scss";
.main-content {
    width: 100vw;
    height: 100vh;
    border-radius: 0;
    overflow-y: scroll;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    .header-container {
        background-color: #fff;
        padding-left: 0;
        box-shadow: none;
        .header-outer {
            background-color: #f4f4f4;
            margin-left: 1.25rem;
            padding: 0;
            box-shadow: none;
            .header-inner {
                background-color: #fff;
                border-bottom-left-radius: 50px;
                margin-left: -1.25rem;
                .header-wrapper {
                    padding: 1.25rem;
                    img {
                        margin-right: 8px;
                        height: 3.125rem;
                        max-width: none;
                        width: auto;
                    }
                }
            }
        }
    }
    .reconsent-body {
        padding: 0;
        margin: 0;
        background-color: #fff;
        .reconsent-main {
            font-size: 16px;
            padding: 20px 0 40px;
            font-family: "DBHeaventRegular";
            background-color: #f4f4f4;
            margin: -1px 1.25rem 0;
            border-top-right-radius: 25px;
            border-bottom-right-radius: 25px;
            border-bottom-left-radius: 25px;
            line-height: 1.5;
            .reconsent-header_single {
                z-index: 9;
                font-family: "DBHeaventRegular";
                color: #65513e;
                font-weight: 600;
                text-align: center;
                width: 100%;
                font-size: 1.5rem;
            }
            .reconsent-header_multi {
                display: flex;
                z-index: 9;
                font-family: "DBHeaventRegular";
                color: #65513e;
                font-weight: 600;
                margin: 0;
                justify-content: space-around;
                width: 100%;
                font-size: 1.5rem;
                .multi_text {
                    &.active {
                        color: #f9613e;
                        border-bottom: 2px solid #f9613e;
                    }
                }
            }
            .reconsent-desc {
                padding: 20px;
                p {
                    text-align: left;
                    margin: 0px 20px;
                }
                li {
                    text-align: left;
                }
            }
        }
        .btn-wrapper {
            padding: 25px 15px;
            .accept-btn {
                font-family: "DBHeaventRegular";
                border-radius: 5px;
                padding: 11px;
                text-align: center;
                background: #65513e;
                font-size: 16px;
                color: #fff;
            }
        }
    }
}
</style>
